import Vue from "vue";
import Vuex from "vuex";

import DarkMode from "./darkMode";
import UserDetails from "./userDetails";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    DarkMode,
    UserDetails,
  },
});
